export default __webpack_public_path__ + "static/media/thumbnail.cc5ac754.webp";